/* eslint-disable no-new */
import Vue from 'vue';

const ComponentInitializer = {
  initVueComponent(component, dataAttribute, additionalConfiguration) {
    const elements = document.querySelectorAll(`[${dataAttribute}]`);
    [...elements].forEach((element) => {
      let configuration = JSON.parse(document.getElementById(element.getAttribute(dataAttribute)).textContent);
      if (!configuration) {
        console.warn(`Configuration object missing: ${dataAttribute}`);
        return;
      }
      configuration.additionalClasses = element.className;
      if (additionalConfiguration) {
        configuration = {
          ...configuration,
          ...additionalConfiguration,
        };
      }
      new Vue({
        el: element,
        render: (h) => h(component, { props: configuration }),
      });
    });
  },
  initVueComponents(dictionary) {
    dictionary.forEach((entry) => this.initVueComponent(
      entry.component,
      entry.dataAttribute,
      entry.configuration,
    ));
  },
};

export default ComponentInitializer;
